export default {
  title: 'Suivi de production',
  breadcrumb: {
    suiviProduction: 'Suivi de production',
  },
  columns: {
    dispositifAFabrique: 'Dispositif - A fabriquer',
    dispositifEnCoursFrabrication: 'Dispositif - En cours de fabrication',
    dispositifFrabricationterminee: 'Dispositif - Fabrication terminée',
    paoBacheCommandees: 'PAO - Bâches commandées',
    paoMaquettesValidees: 'PAO - Maquettes validées',
    impressionsTerminees: 'Impressions - Terminées',
    dispositifAposer: 'Dispositif - A Poser',
    dispositifExpedie: 'Dispositif - Expédié',
    dispositifAFacturer: 'Dispositif - A facturer',
  },
  card: {
    detailCard: {
      messages: 'Messages',
      description: 'Description',
      noDescription: 'Pas de description',
      sujet: 'Sujet',
      noSujet: 'Pas de sujet',
      dateLimite: 'Date limite',
      updateSuccess: 'Votre demande a bien été mise à jour',
      tagInfo: 'Si le tag n\'existe pas il sera créé en validant l\'entrée.',
      visuelCamp: 'Visuel Campagne',
      commercial: 'Commercial',
      assistant: 'Assistant',
    },
  },
  error: {
    impossible: 'Impossible',
    wrongNewItem: 'Problème dans la mise à jour de la card',
    mouvementImpossible: 'Le déplacement entre ses 2 étapes est interdit',
    sujet: 'Sujet',
  },
  filtre: {
    commercial: 'Commercial',
    assistant: 'Assistant',
  },
};
